import React from 'react';
import { Building } from 'lucide-react';

interface BuildingDetailsInputProps {
  value: {
    units: number;
    commonAreas: boolean;
  };
  onChange: (details: { units: number; commonAreas: boolean }) => void;
}

export const BuildingDetailsInput: React.FC<BuildingDetailsInputProps> = ({ value, onChange }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-neutral-700 mb-1">
          Nombre de logements
        </label>
        <input
          type="number"
          value={value.units || ''}
          onChange={(e) => onChange({ ...value, units: parseInt(e.target.value) || 0 })}
          min="1"
          className="input w-full"
          placeholder="Nombre de logements dans l'immeuble"
        />
      </div>

      <label className="flex items-center space-x-3">
        <input
          type="checkbox"
          checked={value.commonAreas}
          onChange={(e) => onChange({ ...value, commonAreas: e.target.checked })}
          className="h-4 w-4 rounded border-neutral-300 text-primary focus:ring-primary"
        />
        <span className="text-neutral-700">
          Inclure la rénovation des parties communes
        </span>
      </label>
    </div>
  );
};